import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { OrdersWithPayment, Order } from 'src/app/models/order';
import { OrderService } from 'src/app/order.service';
import { Router } from '@angular/router';
import { Constants } from 'src/app/constants';
import { Store } from 'src/app/models/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/_services/analytics.service';

@Component({
  selector: 'app-order-summary-item-list',
  templateUrl: './item-list.component.html',
  styleUrls: ['./item-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ItemListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @Input() store:Store;
  @Input() orderHash:string;
  @Input() orderWithPayment:OrdersWithPayment;
  @Input() isAdmin:boolean;
  @Input() disabled: boolean = false;
  @Output() promoConditionsMetChange = new EventEmitter<boolean>();

  formQuantity = Array.from(Array(500).keys()).map(n => n+1);
  displayedColumns: string[] = ['quantity', 'item', 'itemTotal'];
  pizzaOptions:Map<string, string> = Constants.pizzaOptions;
  pizzaOptions$:Map<string, string> = Constants.pizzaOptionsFlag;
  promoHidden:boolean = true;
  promoCode
  promoCodeApplied = false;
  conditionsMet;
  uiSetting:any;

  constructor(
    private orderService:OrderService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
  ) { }

  getFormQuantity(maxQauntity){
    return Array.from(Array(maxQauntity).keys()).map(n => n+1);
  }

  ngOnInit() {
    this.uiSetting = this.store.ui_settings;
    // console.log(this.orderWithPayment.items[0].getItemTotal());
    this.promoCode = this.orderWithPayment.bot_order.promo_code
    this.promoCodeApplied = this.orderWithPayment.bot_order.promo_code.length > 0
    this.promoHidden = !(this.orderWithPayment.bot_order.promo_code.length > 0);
    this.conditionsMet = +this.orderWithPayment.payment.promotional_discount > 0;
    if(this.promoCodeApplied){
      this.promoConditionsMetChange.emit(this.conditionsMet)
    }
  }

  updateQuantity(item:Order){
    if(item.quantity <= 0){
      this.deleteItem(item);
    }else{
      this.orderService.updateQuantity(this.orderHash, item.id, item.quantity).subscribe(data => {
        this.orderService.notifyItemsChanged(this.orderHash || this.orderWithPayment?.bot_order?.order_hash)
      })
    }
  }

  deleteItem(item:Order){
    this.analyticsService.trackEvent('remove_from_cart', {
      item_id: item.menu_item.id,
      item_name: item.menu_item.name,
      price: item.menu_item.base_price,
      quantity: item.quantity
    });
    this.orderService.deleteItem(this.orderHash, item.id).subscribe(data =>{
      this.orderService.notifyItemsChanged(this.orderHash || this.orderWithPayment?.bot_order?.order_hash)
    })
  }

  onSelect(item:Order){
    // parsed_item_id = item.id
    this.router.navigate(['order', this.orderHash,
      'store', this.orderWithPayment.store.id,
      'menu-item-group', item.menu_item.menu_item_group,
      'menu-item',item.menu_item.id,
      'parsed-menu-item',item.id, 'modifiers']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goBack(){
    localStorage.removeItem('menu_group_name');
    localStorage.removeItem('menu_sub_group_name');
    if (this.orderWithPayment.bot_order.is_catering) {
      this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.url_slug, 'catering'])
    } else {
      this.router.navigate(['order', this.orderHash, 'store', this.orderWithPayment.store.id])
    }
  }

  togglePromoCode(){
    this.promoHidden = !this.promoHidden;
  }

  applyPromoCode(code){
    this.orderService.applyPromoCode(this.orderHash, code).subscribe(data => {
      this.promoConditionsMetChange.emit(this.promoCodeApplied && this.conditionsMet)
      this.orderService.notifyItemsChanged(this.orderHash || this.orderWithPayment?.bot_order?.order_hash)
    },error=>{
      this.promoCode = null;
      alert('Invalid Promo Code Entered!')
    })
  }

  removePromoCode(){
    this.orderService.removePromoCode(this.orderWithPayment.bot_order.order_hash).subscribe(data => {
      this.promoConditionsMetChange.emit(true)
      this.orderService.notifyItemsChanged(this.orderHash || this.orderWithPayment?.bot_order?.order_hash)
    })
  }

}
